import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { DocumentRuleCheck, IDocumentRuleCheck } from "@/models/document-rule-check.entity";
import { MrfiktivDocumentRuleCheckControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Module, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { DocumentRuleCheckDataAccessLayer } from "./access-layers/document-rule-check.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { DocumentRuleCheckPageDataProvider } from "./page-data-provider/document-rule-check.page-data-provider";

@Module({
  dynamic: true,
  namespaced: true,
  name: "document-rule-check",
  store
})
export class DocumentRuleCheckPaginationStore extends PaginatedBaseStore<
  IDocumentRuleCheck,
  MrfiktivDocumentRuleCheckControllerGetParamsGen
> {
  protected _data = DocumentRuleCheckDataAccessLayer;
  protected _pageProvider = DocumentRuleCheckPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = DocumentRuleCheck.filterables;
}

export const DocumentRuleCheckModule = getModule(DocumentRuleCheckPaginationStore);
